import type { ConversionEventData } from '@/events/conversion';

import type { ConversionEventType } from '../contracts';
import { TrackerFactory } from './TrackerFactory';

export type ConversionTrackFn = (
  type: ConversionEventType,
  data: ConversionEventData,
  options?: { dedupeKey?: string; origin?: string }
) => void;

export abstract class BaseTracker {
  protected readonly factory: TrackerFactory;

  constructor(factory: TrackerFactory) {
    this.factory = factory;
  }
}
